<div class="container-fluid container-box">
  <div class="row justify-content-center">
    <div class="col-12">
       <app-ag-grid 
       class="center-Pagination d-block position-relative minHeightSet"
       [ngStyle]="{'height': flexHeight}" 
       [dataModel]="dataModel" 
       [rowData]="data?.previewData?.rowData"
       [paginations]="false"
       [columnSettings]="false"
       (gridReady)="onGridReady($event)" >
    </app-ag-grid>
      <app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="data?.isLoading || isLoading"></app-custom-loader>
    </div>
  </div>
  </div> 